import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";

import { Row, Col, CardBody, Card, Container, Form, Label } from "reactstrap";

import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// import images
import profile from "assets/images/profile-img.png";
import logo from "assets/images/Logo.png";
import secureLocalStorage from "react-secure-storage";
import ConfigUrl from "../../config";
import axios from "axios";
import Loader from "pages/Loader";

const LoginOtp = () => {

  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const otp_data = secureLocalStorage.getItem("tempOTP");
  const UserEmail = secureLocalStorage.getItem("UserEmail");
  console.log(secureLocalStorage.getItem("UserEmail"));

  const length = 6

  const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];

  useEffect(() => {
    // if (!otp_data) navigate(`${ConfigUrl.appurl}login`)
  }, [])

  const handleVerifyOtp = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      const response = await axios.post(`${ConfigUrl.apiurl}/auth/user/verify-otp`,
        { email: UserEmail, 
          otp: otpValues.join('') 
        }, {
        headers: {
          'Authorization': `Bearer ${otp_data}`,
          'Content-Type': 'application/json',
        }
      });

      if (response.data.success) {
        setTimeout(() => {
          navigate(`${ConfigUrl.appurl}reset-password`)
        }, 1000);

      }
    } catch (error) {
      setError(error.response.data.message || error.message || "Something went wrong");
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const handleInputChange = (index, event) => {
    const { value } = event.target;
    const newValues = [...otpValues];
    newValues[index] = value;
    setOtpValues(newValues);

    // Move to the next input when a digit is entered
    if (value !== '' && index < length - 1) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleBackspace = (index, event) => {
    if (event.keyCode === 8 && index > 0 && otpValues[index] === '') {
      inputRefs[index - 1].current.focus();
    }
  };

  return (
    <React.Fragment>
      {loading && <Loader/>}
      <div className="account-pages pt-5 ">
        <Container className="">
          <Row className="align-items-center mx-0">
            <Col xl={7}></Col>
            <Col md={8} lg={6} xl={5} >
              <Card className="shadow">
                <div className="bg-primary bg-soft">
                <Row>
                    <Col xs={6}>
                        <div className="text-primary p-4">
                            <h5 className="text-dark">Welcome Back !</h5>
                            <p className="mb-0 text-dark">Enter OTP to verification</p>
                        </div>
                    </Col>
                    <Col className="col-6 p-2 d-flex justify-content-end pe-5">
                        <div className=" profile-user-wid ">
                            <span className="avatar-title rounded-4 px-1 bg-light">
                            <img
                                src={logo}
                                alt=""
                                className="w-100"
                            />
                            </span>
                        </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="p-2 mt-4">
                    <div>
                      {
                        error && <div className="alert alert-danger">{error}</div>
                      }
                    </div>
                    <Form
                      className="form-horizontal"
                      onSubmit={handleVerifyOtp}
                    >
                      <div className="text-center">
                        {otp_data?.message}
                      </div>
                      <div className="text-center fw-bold">{otp_data?.email}</div>

                      <div className='form-field mt-1'>
                        <Label className="form-label"> OTP (One Time Password) <span className="text-danger">*</span></Label>

                        <div className="row mt-2 px-2">
                          {
                            otpValues.map((value, index) => (
                              <div className="col px-2" key={index}>
                                <input
                                  key={index}
                                  ref={inputRefs[index]}
                                  type="text"
                                  className='fs-6 form-control bg-white px-1 text-center text-dark py-2 shadow-sm'
                                  maxLength={1}
                                  value={value}
                                  onChange={(e) => handleInputChange(index, e)}
                                  onKeyDown={(e) => handleBackspace(index, e)}
                                  placeholder="0"
                                  required
                                />
                              </div>
                            ))
                          }

                        </div>
                      </div>

                      <div className="mt-4">

                        <button
                          className="btn btn-primary btn-block w-100"
                          type="submit"
                          disabled={loading}
                        >
                          {
                            loading ?
                              <>
                                <i className="bx bx-hourglass bx-spin align-middle me-2"></i> Verifying...
                              </>
                              : "Verify Now"
                          }
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default LoginOtp;